import React from "react";
import {Button} from "@/components/ui/button";
import BasePopup from "./BasePopup";
import { Link } from "react-router-dom";

const TermsOfUsePopup = ({isOpen, onClose}) => {
    return (
        <BasePopup isOpen={isOpen} onClose={onClose}>
            <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-gray-900">Terms of Service</h3>
                <p className="text-gray-600 mt-2">Last updated: April 2025</p>
            </div>

            <div className="bg-blue-50 rounded-lg p-4 mb-5 text-sm max-h-72 overflow-y-auto">
                <div className="text-gray-700 space-y-4">
                    <p>
                        Welcome to JobPool.ai. By accessing or using our services, you agree to the following Terms of
                        Use. Please read them carefully.
                    </p>

                    <h4 className="font-semibold text-gray-800">1. Account Registration</h4>
                    <p>
                        You must provide accurate and complete information during registration. You are responsible for
                        all activity under your account and for maintaining the confidentiality of your credentials.
                    </p>

                    <h4 className="font-semibold text-gray-800">2. Permitted Use</h4>
                    <p>
                        Our platform is intended solely for personal job search and career exploration. You may not
                        copy, scrape, resell, or exploit any data or content from the platform without permission.
                    </p>

                    <h4 className="font-semibold text-gray-800">3. AI-Generated Content</h4>
                    <p>
                        Job recommendations are generated using artificial intelligence based on your resume and
                        preferences. We do not guarantee accuracy, completeness, or employment outcomes.
                    </p>

                    <h4 className="font-semibold text-gray-800">4. User Content</h4>
                    <p>
                        You are solely responsible for the content you provide, including resumes, preferences, and any
                        other data submitted. You agree not to upload misleading, unlawful, or harmful content.
                    </p>

                    <h4 className="font-semibold text-gray-800">5. Payments & Refunds</h4>
                    <p>
                        All purchases are final. Due to the nature of our digital product, no refunds will be issued
                        after your report has been generated. Please review all details before completing your purchase.
                    </p>

                    <h4 className="font-semibold text-gray-800">6. Intellectual Property</h4>
                    <p>
                        All content, branding, software, and materials on this platform are the property of JobPool.ai.
                        You may not copy, distribute, or use any part of the platform without prior written consent.
                    </p>

                    <h4 className="font-semibold text-gray-800">7. Suspension or Termination</h4>
                    <p>
                        We reserve the right to suspend or terminate your access at any time if you violate these terms
                        or engage in activity that harms the platform or other users.
                    </p>

                    <h4 className="font-semibold text-gray-800">8. Governing Law</h4>
                    <p>
                        These Terms of Service shall be governed by and interpreted in accordance with the laws of the
                        United States, without regard to its conflict of law principles. You agree that any dispute or
                        claim arising out of or in connection with these Terms or your use of the Service shall be
                        subject to the exclusive jurisdiction of competent courts within the United States.
                    </p>
                    <p>
                        If you access or use the Service from outside the United States, you do so at your own risk and
                        are responsible for compliance with applicable local laws. We make no representation that the
                        Service is appropriate or available in all jurisdictions.
                    </p>

                    <h4 className="font-semibold text-gray-800">9. Modifications</h4>
                    <p>
                        We reserve the right to modify these Terms at any time. Updated terms will be posted on this
                        page with the date of the last update. Your continued use of the Service constitutes acceptance
                        of the revised Terms.
                    </p>

                    <h4 className="font-semibold text-gray-800">10. Privacy Policy</h4>
                    <p>
                        To understand how we collect, use, and protect your personal data,
                        please review our <Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link>.
                    </p>
                </div>
            </div>

            <Button
                className="w-full bg-blue-600 hover:bg-blue-700 h-10 text-sm font-medium rounded-lg"
                onClick={onClose}
            >
                I Understand
            </Button>
        </BasePopup>
    );
};

export default TermsOfUsePopup; 